(function () {
  'use strict';

  var STORAGE_MEMBER_HIDDEN = 'theme:new-customer-coupon-teaser-hidden';
  var DEFAULT_HIDE_HOURS = 24;

  var dock = document.getElementById('ulefone-floating-dock');
  if (!dock) return;

  var items = {
    member: dock.querySelector('[data-dock-item="member"]'),
    ai: dock.querySelector('[data-dock-item="ai"]'),
  };

  function setItemVisible(key, visible) {
    var el = items[key];
    if (!el) return;
    if (visible) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
    syncDockVisibility();
  }

  function syncDockVisibility() {
    var any = Object.keys(items).some(function (key) {
      return items[key] && !items[key].hasAttribute('hidden');
    });
    if (any) {
      dock.removeAttribute('hidden');
      document.body.classList.add('floating-dock-active');
    } else {
      dock.setAttribute('hidden', '');
      document.body.classList.remove('floating-dock-active');
    }
  }

  function getHideHours() {
    if (window.UlefoneNewMemberBonus && typeof window.UlefoneNewMemberBonus.getTeaserHideHours === 'function') {
      return window.UlefoneNewMemberBonus.getTeaserHideHours();
    }
    var popup = document.querySelector('new-customer-coupon-popup');
    var hours = parseInt(popup && popup.dataset ? popup.dataset.teaserHideHours : '', 10);
    if (!hours || hours < 1) return DEFAULT_HIDE_HOURS;
    return Math.min(hours, 72);
  }

  function isMemberInCooldown() {
    if (window.UlefoneNewMemberBonus && typeof window.UlefoneNewMemberBonus.isTeaserInCooldown === 'function') {
      return window.UlefoneNewMemberBonus.isTeaserInCooldown();
    }
    var raw = localStorage.getItem(STORAGE_MEMBER_HIDDEN);
    if (!raw) return false;
    if (raw === 'true') {
      localStorage.removeItem(STORAGE_MEMBER_HIDDEN);
      return false;
    }
    var until = parseInt(raw, 10);
    if (!until) return false;
    if (Date.now() >= until) {
      localStorage.removeItem(STORAGE_MEMBER_HIDDEN);
      return false;
    }
    return true;
  }

  function startMemberCooldown() {
    if (window.UlefoneNewMemberBonus && typeof window.UlefoneNewMemberBonus.startTeaserCooldown === 'function') {
      window.UlefoneNewMemberBonus.startTeaserCooldown(getHideHours());
      return;
    }
    var ms = getHideHours() * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_MEMBER_HIDDEN, String(Date.now() + ms));
  }

  function setupAi() {
    var hasChat = !!document.getElementById('chatbot-window');
    setItemVisible('ai', hasChat);
  }

  function shouldShowMemberFromStorage() {
    if (isMemberInCooldown()) return false;
    var popup = document.querySelector('new-customer-coupon-popup');
    if (!popup || !popup.hasAttribute('data-show-teaser')) return false;

    var orderCount = popup.dataset.loggedInOrderCount;
    if (orderCount !== '' && orderCount != null && parseInt(orderCount, 10) > 0) {
      return false;
    }

    var inst =
      window.UlefoneNewMemberBonus && typeof window.UlefoneNewMemberBonus.getInstance === 'function'
        ? window.UlefoneNewMemberBonus.getInstance()
        : null;
    if (inst && typeof inst.shouldShowTeaser === 'function') {
      return !!inst.shouldShowTeaser();
    }

    var claimed = localStorage.getItem('theme:new-customer-coupon-claimed') === 'true';
    var dismissed = localStorage.getItem('theme:new-customer-coupon-dismissed') === 'true';
    return claimed || dismissed;
  }

  function setupMember() {
    // Don't rely only on the popup event — it can fire before this dock listens.
    setItemVisible('member', shouldShowMemberFromStorage());
  }

  function openMember() {
    if (window.UlefoneNewMemberBonus && typeof window.UlefoneNewMemberBonus.open === 'function') {
      window.UlefoneNewMemberBonus.open();
    }
  }

  function closeMember(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    startMemberCooldown();
    setItemVisible('member', false);
    document.dispatchEvent(new CustomEvent('ulefone:member-teaser-closed'));
  }

  dock.addEventListener('click', function (e) {
    var close = e.target.closest('[data-dock-close]');
    if (close) {
      if (close.getAttribute('data-dock-close') === 'member') closeMember(e);
      return;
    }

    var actionBtn = e.target.closest('[data-dock-action]');
    if (!actionBtn) return;
    if (actionBtn.getAttribute('data-dock-action') === 'member') openMember();
  });

  document.addEventListener('ulefone:member-teaser-visibility', function (e) {
    if (isMemberInCooldown()) {
      setItemVisible('member', false);
      return;
    }
    setItemVisible('member', !!(e.detail && e.detail.visible));
  });

  function init() {
    setupAi();
    setupMember();
    syncDockVisibility();
    // Popup CE may connect slightly later — re-sync a few times.
    setTimeout(setupMember, 100);
    setTimeout(setupMember, 500);
    setTimeout(setupMember, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
